import React from "react";
import { Shield, GraduationCap, Radio, ChartBar, FileSearch, Users, ArrowRight } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const servicesData = [{
  title: "Στρατιωτικά Έγγραφα & Διεκπεραιώσεις",
  description: "Παρέχουμε ολοκληρωμένη υποστήριξη για τη διαχείριση και διεκπεραίωση στρατιωτικών εγγράφων και αιτήσεων προς τις αρμόδιες υπηρεσίες.\n\nΑναλαμβάνουμε τη σωστή προετοιμασία του φακέλου σας, την αποφυγή λαθών και καθυστερήσεων, καθώς και την ορθή καθοδήγηση σε κάθε στάδιο της διαδικασίας.\n\nΣτόχος μας είναι να μειώσουμε τη γραφειοκρατία και να εξασφαλίσουμε ότι κάθε ενέργεια γίνεται σωστά και έγκαιρα.",
  icon: Shield
}, {
  title: "Μεταθέσεις & Τοποθετήσεις",
  description: "Αναλαμβάνουμε την υποστήριξη και καθοδήγηση για αιτήσεις μετάθεσης και τοποθέτησης σε Ένοπλες Δυνάμεις και Σώματα Ασφαλείας. Εξετάζουμε κάθε περίπτωση ξεχωριστά και παρέχουμε στρατηγική προσέγγιση ώστε να αυξηθούν οι πιθανότητες θετικής έκβασης.\n\n\nΗ διαδικασία γίνεται με προσοχή στη λεπτομέρεια και πλήρη κατανόηση των διοικητικών απαιτήσεων.",
  icon: GraduationCap
}, {
  title: "Αναβολές & Απαλλαγές",
  description: "Παρέχουμε υπεύθυνη καθοδήγηση για διαδικασίες αναβολής ή απαλλαγής από στρατιωτικές υποχρεώσεις, σύμφωνα με την ισχύουσα νομοθεσία και τις διοικητικές διαδικασίες.\n\n\nΣας βοηθάμε να προετοιμάσετε σωστά τον φάκελό σας και να κινηθείτε με ασφάλεια και ενημέρωση σε κάθε βήμα.",
  icon: Radio
}, {
  title: "Νομική & Διοικητική Υποστήριξη",
  description: "Παρέχουμε συμβουλευτική υποστήριξη για διοικητικά και νομικά ζητήματα που αφορούν στρατιωτικές υποθέσεις και σώματα ασφαλείας. Στόχος μας είναι η σωστή ενημέρωση και καθοδήγηση ώστε να αποφεύγονται λάθη που μπορούν να επηρεάσουν την υπόθεσή σας.\n\n\nΗ προσέγγισή μας είναι υπεύθυνη, διακριτική και βασισμένη στην εμπειρία.",
  icon: ChartBar
}, {
  title: "Υποστήριξη Στρατιωτών & Οικογένειας",
  description: "Στεκόμαστε δίπλα σε στρατιωτικούς και τις οικογένειές τους, προσφέροντας πρακτική υποστήριξη σε ζητήματα που προκύπτουν κατά τη διάρκεια της θητείας ή της υπηρεσίας.\n\n\nΑντιμετωπίζουμε κάθε περίπτωση με σεβασμό, κατανόηση και στόχο τη βελτίωση της καθημερινότητας των στελεχών.",
  icon: FileSearch
}, {
  title: "Συμβουλευτική Καθοδήγηση",
  description: "Παρέχουμε εξατομικευμένη συμβουλευτική καθοδήγηση για όλα τα θέματα που αφορούν Ένοπλες Δυνάμεις και Σώματα Ασφαλείας. Αναλύουμε την περίπτωσή σας και σας καθοδηγούμε βήμα-βήμα για τις σωστές αποφάσεις.\n\n\nΣτόχος μας είναι η ασφάλεια, η σωστή πληροφόρηση και η στρατηγική προσέγγιση κάθε υπόθεσης.",
  icon: Users
}];
export default function SpecializedServices() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const delayClasses = ["delay-0", "delay-100", "delay-200", "delay-300", "delay-400", "delay-500"];
  return <section data-section-id="54357" id="οι-υπηρεσίες-μας" className="py-24 bg-background relative text-foreground" ref={ref}>
      <div className="container mx-auto px-4 sm:px-6 md:px-8 max-w-7xl">
        <div className={`transition-all duration-700 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-100 translate-y-0 md:opacity-0 md:translate-y-10"}`}>
          <div className="text-center mb-16 max-w-3xl mx-auto">
            <h2 className="text-3xl md:text-5xl font-default font-bold text-primary mb-4">
              Οι Υπηρεσίες μας
            </h2>
            <p className="text-muted-foreground font-sans text-xl">
              Ολοκληρωμένες λύσεις και εξειδικευμένη συμβουλευτική υποστήριξη προσαρμοσμένη στις ιδιαίτερες ανάγκες του σύγχρονου ένστολου προσωπικού.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
            {servicesData.map((service, index) => {
            const Icon = service.icon;
            const delayClass = delayClasses[index] || "delay-0";
            return <div key={index} data-index={index} className={`transition-all duration-700 ease-out ${delayClass} ${isVisible ? "opacity-100 translate-y-0" : "opacity-100 translate-y-0 md:opacity-0 md:translate-y-10"}`}>
                  <Card className="w-full h-full flex flex-col border border-border shadow-sm hover:shadow-lg hover:-translate-y-1 transition-all duration-300 bg-card rounded-lg overflow-visible">
                    <CardHeader className="pb-6 bg-[#4CAF50] pt-8">
                      <div className="w-12 h-12 rounded-lg bg-white/20 flex items-center justify-center mb-4 text-white">
                        <Icon className="w-6 h-6" />
                      </div>
                      <CardTitle className="font-default text-2xl font-bold text-white leading-tight min-h-[3.5rem] flex items-center">
                        {service.title}
                      </CardTitle>
                    </CardHeader>
                    <CardContent className="flex-grow bg-white p-6">
                      <p className="text-lg text-primary font-sans leading-relaxed">
                        {service.description}
                      </p>
                    </CardContent>
                    <CardFooter className="pt-4 bg-white pb-6 px-6">
                      <Button variant="ghost" className="p-0 h-auto font-bold text-primary hover:text-[#1AE664] hover:bg-transparent group" asChild>
                        
                      </Button>
                    </CardFooter>
                  </Card>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}